module.exports = __webpack_public_path__ + "static/media/icon1.68d8db0d.svg";